/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import { IconButton, Modal } from '@mui/material';
import { css } from '@emotion/react';
import LogoMenu from '../../../assets/imgs/logo_menu.svg';
import MenuIcon from '../../../assets/icons/menu_icon.svg';
import { useTranslation } from 'react-i18next';
import ButtonText from '../../../design/button-text/ButtonText';
import { PageBlockId, Paths } from '../../../shared/constants';
import { useAppNavigation } from '../../../context/AppNavigationContext';
import MenuModal from '../../../layout/header/MenuModal/MenuModal';
import theme from '../../../styles/theme';

export default function Navigation() {
  const { scrollToBlock, activeBlock } = useAppNavigation();
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  function handleModalOpen() {
    setModalOpen(true);
  }

  function handleClose() {
    setModalOpen(false);
  }

  return (
    <header css={styles.headerWrapper}>
      <div css={styles.headerPanelWrapper}>
        <div>
          <a href='/'>
            <LogoMenu />
          </a>
        </div>
        <div css={styles.navigationWrapper}>
          <ButtonText
            styles={styles.navigationButton}
            active={activeBlock === PageBlockId.aboutUs}
            onClick={() => scrollToBlock(Paths.home, PageBlockId.aboutUs)}
          >
            {t('header.aboutUsButton')}
          </ButtonText>
          <ButtonText
            styles={styles.navigationButton}
            active={activeBlock === PageBlockId.career}
            onClick={() => scrollToBlock(Paths.career, PageBlockId.career)}
          >
            {t('header.projectsButton')}
          </ButtonText>
          <ButtonText
            styles={styles.navigationButton}
            active={activeBlock === PageBlockId.teams}
            onClick={() => scrollToBlock(Paths.home, PageBlockId.teams)}
          >
            {t('header.teamsButton')}
          </ButtonText>
          <ButtonText
            styles={styles.navigationButton}
            active={activeBlock === PageBlockId.iss}
            onClick={() => scrollToBlock(Paths.iss, PageBlockId.iss)}
          >
            {t('header.informationServicesButton')}
          </ButtonText>
          <ButtonText
            styles={styles.navigationButton}
            active={activeBlock === PageBlockId.contact}
            onClick={() => scrollToBlock(Paths.home, PageBlockId.contact)}
          >
            {t('header.careerButton')}
          </ButtonText>
          <ButtonText
            styles={styles.navigationButton}
            active={activeBlock === PageBlockId.projects}
            onClick={() => scrollToBlock(Paths.home, PageBlockId.projects)}
          >
            {t('header.contactButton')}
          </ButtonText>
          <div css={styles.menuAndLanguageWrapper}>
            <IconButton css={styles.menuIconButton} onClick={handleModalOpen}>
              <MenuIcon />
            </IconButton>
          </div>
        </div>
      </div>
      <Modal
        css={styles.menuModal}
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <MenuModal close={handleClose} />
      </Modal>
    </header>
  );
}

const styles = {
  headerWrapper: css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1100;
    background: ${theme.palette.background.default};
  `,
  headerPanelWrapper: css`
    display: flex;
    background: ${theme.palette.background.default};
    height: 80px;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    padding: 0 24px 0 48px;
    @media (min-width: ${theme.breakpoints.values.sm}px) {
      padding: 0 44px 0 86px;
    }
  `,
  navigationWrapper: css`
    display: flex;
    gap: 32px;
  `,
  navigationButton: css`
    display: none;
    @media (min-width: ${theme.breakpoints.values.md}px) {
      display: unset;
    }
  `,
  menuAndLanguageWrapper: css`
    display: flex;
    align-items: center;
    gap: 16px;
    @media (min-width: ${theme.breakpoints.values.sm}px) {
      gap: 28px;
    }
    @media (min-width: ${theme.breakpoints.values.md}px) {
      display: none;
    }
  `,
  menuIconButton: css`
    height: 36px;
    width: 36px;
  `,
  menuModal: css`
    overflow: auto;
  `,
};
